module.exports = __webpack_public_path__ + "144a2b811eb17a3a7d07c77e291091c0.svg";